import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5b8eee8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Shopify Order Recovery", -1))
const _hoisted_3 = { clas: "filters" }
const _hoisted_4 = { class: "shop-finder" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Shop URL:")
const _hoisted_6 = {
  key: 0,
  class: "k-icon k-font-icon k-i-loading",
  style: {"color":"white","font-weight":"700"}
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "shop-info"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "error" }
const _hoisted_11 = {
  key: 2,
  class: "filter-box"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  title: "You can add multiple merchant order ids separated by comma.\r\n i.e. 6252801786197, 6252800377173, 6252798509397",
  class: "k-icon k-font-icon k-i-information"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Merchant order id(s):")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("From:")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("To:")
const _hoisted_16 = { class: "file-upload" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  title: "You can upload the CSV exported from Shopify to filter the orders.\r\nTo remove the upload click on 'Choose File' and then 'Cancel'.",
  class: "k-icon k-font-icon k-i-information"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Csv upload:")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Retrieve ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Import all ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Force Processing ")
const _hoisted_23 = {
  key: 0,
  class: "loader"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "k-icon k-font-icon k-i-loading",
  style: {"font-size":"64px"}
}, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: "results"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "orders-header" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div", null, "Order"),
  /*#__PURE__*/_createElementVNode("div", null, "Customer"),
  /*#__PURE__*/_createElementVNode("div", null, "Date"),
  /*#__PURE__*/_createElementVNode("div", null, "Order Id"),
  /*#__PURE__*/_createElementVNode("div", null, "Actions")
], -1))
const _hoisted_29 = { class: "order-row" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Hub Order ")
const _hoisted_32 = ["href"]
const _hoisted_33 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 0,
  class: "k-icon k-font-icon k-i-loading",
  style: {"color":"white","font-weight":"700"}
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-items-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Variant"),
  /*#__PURE__*/_createElementVNode("div", null, "Quantity"),
  /*#__PURE__*/_createElementVNode("div", null, "Price"),
  /*#__PURE__*/_createElementVNode("div", null, "Sku")
], -1))
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = {
  key: 0,
  class: "k-icon k-font-icon k-i-loading",
  style: {"color":"white","font-weight":"700"}
}
const _hoisted_42 = { key: 1 }

import "@/assets/css/action-buttons.css";
import { Label as KLabel } from "@progress/kendo-vue-labels";
import {
  Input as KInput,
  Checkbox as KCheckbox,
} from "@progress/kendo-vue-inputs";
import { Button as KButton } from "@progress/kendo-vue-buttons";
import { DatePicker as KDatePicker } from "@progress/kendo-vue-dateinputs";
import moment from "moment";

import type {
  Filters,
  ShopifyLineItem,
  ShopifyOrder,
  ShopifyShop,
} from "@/core/types/shopify";
import * as Shopify from "@/core/services/shopifyOrderRecoveryService";
import { strIsoOfDate } from "@/views/SuperAdminManagment/Commissions/helpers";
import { Notification as KNotification } from "@progress/kendo-popups-vue-wrapper";


import { defineComponent, ref, Ref, computed, onMounted } from "vue";

const __default__ = defineComponent({
  name: "ShopifyOrdersRecovery",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const shopUrl = ref("");
const shopDetails: Ref<ShopifyShop | null> = ref(null);
const shopError = ref("");
const selectAll = ref(true);

const resultLoading = ref(false);
const findLoading = ref(false);

const filters: Ref<Filters> = ref({} as Filters);
const csvFilter: Ref<Filters> = ref({} as Filters);
const retrieveRequested = ref(false);
const shopifyOrders: Ref<ShopifyOrder[]> = ref([]);
const popupNotification: any = ref(null);
let popupNotificationWidget: any = null;

onMounted(() => {
  popupNotificationWidget = popupNotification.value?.kendoWidget();
});

const shopExists = computed(() => shopDetails.value !== null);
const showResult = computed(
  () =>
    shopExists.value &&
    retrieveRequested.value &&
    shopifyOrders.value.length > 0,
);
const noResults = computed(
  () =>
    shopExists.value &&
    retrieveRequested.value &&
    shopifyOrders.value.length == 0,
);

const toggleAllLabel = computed(() =>
  selectAll.value ? "Select all" : "Unselect all",
);

const onFind = async () => {
  if (!shopUrl.value) return;
  try {
    findLoading.value = true;
    shopDetails.value = null;
    shopError.value = "";
    shopDetails.value = await Shopify.findShop(shopUrl.value);
  } catch (error: any) {
    shopError.value = error.message;
  } finally {
    findLoading.value = false;
  }
};

const onRetrieve = async () => {
  try {
    shopifyOrders.value = [];
    resultLoading.value = true;
    retrieveRequested.value = true;
    const finalFilters = csvFilter.value.OrderIds
      ? csvFilter.value
      : filters.value;
    finalFilters.ShopUrl = shopUrl.value;
    shopifyOrders.value = await Shopify.retrieveOrders(finalFilters);
  } catch (error: any) {
    console.error("onRetrieve::error", error);
    popupNotificationWidget.show("Retrieve failed", "error");
  } finally {
    resultLoading.value = false;
  }
};

const onSelectAll = () => {
  for (const order of shopifyOrders.value) {
    order.Selected = !order.Selected;
  }

  selectAll.value = !selectAll.value;
};

const onSave = async () => {
  try {
    const orders = shopifyOrders.value.filter(o => o.Selected);
    if (!orders.length) {
      popupNotificationWidget.show("No orders selected", "warning");
      return;
    }
    const result = await Shopify.save(shopUrl.value, orders);
    popupNotificationWidget.show("Orders saved", "success");
  } catch (error: any) {
    console.error("onSave::error", error);
    popupNotificationWidget.show("Save failed", "error");
  }
};

const onImportAll = async () => {
  try {
    const orders = shopifyOrders.value.filter(o => o.Selected);
    if (!orders.length) {
      popupNotificationWidget.show("No orders selected", "warning");
      return;
    }

    const result = await Shopify.importAll(shopUrl.value, orders);
    popupNotificationWidget.show("Orders queued for import", "success");
  } catch (error: any) {
    console.error("onImportOrder::error", error);
    popupNotificationWidget.show("Import failed", "error");
  }
};

const onImportOrder = async (order: ShopifyOrder) => {
  try {
    order.IsImporting = true;
    const result = await Shopify.importOrder(shopUrl.value, order);
    popupNotificationWidget.show("Order queued for import", "success");
  } catch (error: any) {
    console.error("onImportOrder::error", error);
    popupNotificationWidget.show(
      `Import of order ${order.Number} failed`,
      "error",
    );
  } finally {
    order.IsImporting = false;
  }
};

const onChangeSku = (lineItem: ShopifyLineItem) => {
  const orders = shopifyOrders.value.filter(o => !o.AlreadyImported);
  const { VariantId, Sku } = lineItem;
  const lineItems = orders
    .flatMap(o => o.LineItems)
    .filter(li => li.VariantId == VariantId);
  for (const li of lineItems) {
    li.Sku = Sku;
  }
};

const onFileChanged = (event: any) => {
  const file = event.target.files[0];
  if (file) {
    const rdr = new FileReader();
    rdr.onload = (e: any) => {
      const content = e.target.result;
      const parseResult = Shopify.parseCsv(content);
      const distinct = parseResult.reduce((acc, val) => {
        if (!acc.find((o: any) => o.Name == val.Name)) {
          acc.push(val);
        }

        return acc;
      }, []);
      csvFilter.value.OrderIds = distinct.map((o: any) => o.Id).join(",");
    };

    rdr.readAsText(file);
  } else {
    csvFilter.value.OrderIds = "";
  }
};
const onOrderIdChange = (event: any) => {
  filters.value.OrderIds = event.target.value;
};

const onFromChange = (event: any) => {
  filters.value.StartDate = strIsoOfDate(event.target.value);
};

const onToChange = (event: any) => {
  filters.value.EndDate = strIsoOfDate(event.target.value);
};

const onShopUrlChange = (event: any) => {
  shopUrl.value = event.target.value.trim();
};

const onForceProcessing = async () => {
  try {
    const result = await Shopify.forceProcessing();
    popupNotificationWidget.show("Processing forced", "success");
  } catch (error: any) {
    console.error("onForceProcessing::error", error);
    popupNotificationWidget.show("Force processing failed", "error");
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(KLabel), { for: 'shop-url' }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_unref(KInput), {
          id: 'shop-url',
          "default-value": shopUrl.value,
          onChange: onShopUrlChange
        }, null, 8, ["default-value"]),
        _createVNode(_unref(KButton), {
          class: "action primary",
          disabled: findLoading.value,
          onClick: onFind
        }, {
          default: _withCtx(() => [
            (findLoading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, "Find"))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      (_unref(shopExists))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("span", null, "Owned by " + _toDisplayString(shopDetails.value?.OwnerFullName) + " (" + _toDisplayString(shopDetails.value?.OwnerEmail) + ")", 1)
          ]))
        : _createCommentVNode("", true),
      (shopError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(shopError.value), 1)
          ]))
        : _createCommentVNode("", true),
      (_unref(shopExists))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _hoisted_12,
              _createVNode(_unref(KLabel), { for: 'order-id' }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createVNode(_unref(KInput), {
                id: 'order-id',
                "default-value": filters.value.OrderIds,
                onChange: onOrderIdChange
              }, null, 8, ["default-value"]),
              _createVNode(_unref(KLabel), { for: 'from' }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(_unref(KDatePicker), {
                id: 'from',
                "default-value": filters.value.StartDate,
                onChange: onFromChange
              }, null, 8, ["default-value"]),
              _createVNode(_unref(KLabel), { for: 'to' }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }),
              _createVNode(_unref(KDatePicker), {
                id: 'to',
                "default-value": filters.value.EndDate,
                onChange: onToChange
              }, null, 8, ["default-value"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_unref(KLabel), { for: 'csv' }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }),
              _createElementVNode("input", {
                id: "csv",
                type: "file",
                accept: "text/csv",
                onChange: onFileChanged
              }, null, 32)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_unref(KButton), {
                class: "action primary",
                onClick: onRetrieve
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }),
              (_unref(showResult) && !_unref(noResults))
                ? (_openBlock(), _createBlock(_unref(KButton), {
                    key: 0,
                    class: "action primary",
                    onClick: onSelectAll
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(toggleAllLabel)), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(showResult) && !_unref(noResults))
                ? (_openBlock(), _createBlock(_unref(KButton), {
                    key: 1,
                    class: "action secondary",
                    onClick: onSave
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(showResult) && !_unref(noResults))
                ? (_openBlock(), _createBlock(_unref(KButton), {
                    key: 2,
                    class: "action secondary",
                    onClick: onImportAll
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(showResult) && !_unref(noResults))
                ? (_openBlock(), _createBlock(_unref(KButton), {
                    key: 3,
                    class: "action secondary",
                    onClick: onForceProcessing
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (resultLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
      : _createCommentVNode("", true),
    (_unref(showResult))
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          (_unref(noResults))
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, "No orders found"))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(shopifyOrders.value, (order) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: order.Id
                }, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", null, [
                      (!order.AlreadyImported)
                        ? (_openBlock(), _createBlock(_unref(KCheckbox), {
                            key: 0,
                            value: order.Selected
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, _toDisplayString(order.Number), 1)
                    ]),
                    _createElementVNode("div", null, _toDisplayString(order.BuyerEmail), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(moment)(order.PaidAt).format("DD MMM 'YY h:mm:ssa")), 1),
                    _createElementVNode("div", null, _toDisplayString(order.Id), 1),
                    _createElementVNode("div", null, [
                      (order.AlreadyImported)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                            _hoisted_31,
                            _createElementVNode("a", {
                              target: "_blank",
                              href: order.FormUrl
                            }, "#" + _toDisplayString(order.HubOrderId), 9, _hoisted_32),
                            _hoisted_33,
                            _hoisted_34,
                            _createTextVNode(" Imported on " + _toDisplayString(_unref(moment)(order.ImportedOn).format("DD MMM 'YY h:mm:ssa")) + ". ", 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_35, [
                            _createVNode(_unref(KButton), {
                              disabled: order.IsImporting,
                              class: "action primary",
                              onClick: ($event: any) => (onImportOrder(order))
                            }, {
                              default: _withCtx(() => [
                                (order.IsImporting)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_36))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_37, "Import"))
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"])
                          ]))
                    ])
                  ]),
                  _hoisted_38,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.LineItems, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.Id,
                      class: "line-item-row"
                    }, [
                      _createElementVNode("div", null, _toDisplayString(item.Name), 1),
                      _createElementVNode("div", null, _toDisplayString(item.Quantity) + " item(s)", 1),
                      _createElementVNode("div", null, _toDisplayString(item.Price), 1),
                      _createElementVNode("div", null, [
                        (order.AlreadyImported)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(item.Sku), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_40, [
                              _createVNode(_unref(KInput), {
                                modelValue: item.Sku,
                                "onUpdate:modelValue": ($event: any) => ((item.Sku) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createVNode(_unref(KButton), {
                                disabled: order.IsImporting,
                                class: "action primary",
                                onClick: ($event: any) => (onChangeSku(item))
                              }, {
                                default: _withCtx(() => [
                                  (order.IsImporting)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_41))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_42, "Change"))
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"])
                            ]))
                      ])
                    ]))
                  }), 128))
                ], 64))
              }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(KNotification), {
      ref_key: "popupNotification",
      ref: popupNotification
    }, null, 512)
  ]))
}
}

})